import { Component, Input, OnInit } from '@angular/core';
import { JournalPost } from '../../interfaces/journal-post';

@Component({
  selector: 'app-journal-posts-grid',
  templateUrl: './journal-posts-grid.component.html',
  styleUrls: ['./journal-posts-grid.component.scss']
})
export class JournalPostsGridComponent implements OnInit {
  @Input() posts: JournalPost[];
  @Input() cascade: boolean;

  constructor() { }

  ngOnInit() {
  }

}
